import { publicObj, viewsObj } from './public';
let enObj = require('./en.json');
let hkObj = require('./zh-hk.json');
let cnObj = require('./zh-cn.json');

let  newLangObj={}
let oldnewLangObj = Object.getOwnPropertyNames(enObj).length>= Object.getOwnPropertyNames(hkObj).length?Object.assign({},enObj):Object.assign({},hkObj)
for(let nowkey in oldnewLangObj){
  newLangObj[nowkey]={
    'en':enObj[nowkey]||'',
    'zh-cn':cnObj[nowkey]||'',
    'zh-hk': hkObj[nowkey]||'',
  }
}
const EN = 'en';
const CN = 'zh-cn';
const HK = 'zh-hk';

const langObj =  (function() {
  const langObj = {
    [EN]: {},
    [CN]: {},
    [HK]:{}
  }

  const obj = Object.assign({},publicObj,viewsObj,newLangObj)

  const arr = Object.entries(obj);
  arr.forEach(item => {
    const [key, value] = item;

    const en = value[EN];
    const cn = value[CN];
    const hk = value[HK];

    langObj[EN][key] = en;
    langObj[CN][key] = cn;
    langObj[HK][key] = hk;
  });

  console.log(2222222222,langObj);
  return langObj;
})();

export default langObj;



// WEBPACK FOOTER //
// ./src/utils/locales/index.js